import { Phone, Video, Building2 } from "lucide-react";

export const TYPE_META = {
  telefono: { label: "Telefonata", icon: Phone },
  video: { label: "Videochiamata", icon: Video },
  ufficio: { label: "In ufficio", icon: Building2 },
};

export const TypePicker = ({ types, value, onChange }) => (
  <div className="grid grid-cols-3 gap-2" data-testid="type-picker">
    {types.map((t) => {
      const M = TYPE_META[t];
      const I = M.icon;
      return (
        <button key={t} type="button" data-testid={`type-${t}`} onClick={() => onChange(t)}
          className={`rounded-xl border p-3 flex flex-col items-center gap-1.5 text-sm transition-colors ${value === t ? "border-sky-600 bg-sky-50 text-sky-800" : "border-slate-200 bg-white hover:border-sky-400"}`}>
          <I className="h-5 w-5" /> {M.label}
        </button>
      );
    })}
  </div>
);
